import { render, staticRenderFns } from "./no-use.vue?vue&type=template&id=48c20a57&scoped=true"
import script from "./no-use.vue?vue&type=script&lang=js"
export * from "./no-use.vue?vue&type=script&lang=js"
import style0 from "./no-use.vue?vue&type=style&index=0&id=48c20a57&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c20a57",
  null
  
)

export default component.exports